export const SET_HEADER_QUESTION_TITLE = 'SET_HEADER_QUESTION_TITLE';

export const SET_HEADER_FILE_NAME = 'SET_HEADER_FILE_NAME';

export const SET_HEADER_BREADCRUMB = 'SET_HEADER_BREADCRUMB';